import { render, staticRenderFns } from "./distributeDetails.vue?vue&type=template&id=d1d76dbc&scoped=true"
import script from "./distributeDetails.vue?vue&type=script&lang=js"
export * from "./distributeDetails.vue?vue&type=script&lang=js"
import style0 from "./distributeDetails.vue?vue&type=style&index=0&id=d1d76dbc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d1d76dbc",
  null
  
)

export default component.exports